'use client';

import { TBlogModuleCenter } from '@/app/(blogposts)/blog/blog.types';
import { Button } from '@/components/ui/Button';
import { Typography } from '@/components/ui/Text';
import { useCallback, useState } from 'react';
import { BlogArticleModuleCentersCardMobile } from '../BlogArticleModuleCentersCardMobile';

import './BlogArticleModuleCentersMobile.scss';

type Props = {
  module: TBlogModuleCenter;
};

export const BlogArticleModuleCentersMobile: React.FC<Props> = ({
  module: { title, subtitle, locations },
}) => {
  const [selected, setSelected] = useState<undefined | number>(undefined);

  const handleClick = useCallback(
    (id: number | null) =>
      setSelected(prevValue =>
        id === prevValue ? undefined : id || undefined
      ),
    []
  );

  return (
    <div className='BlogArticleModuleCentersMobile'>
      <Typography
        className='BlogArticleModuleCentersMobile__title'
        variant='h3'
      >
        {title}
      </Typography>

      <Typography
        className='BlogArticleModuleCentersMobile__subtitle'
        variant='body'
      >
        {subtitle}
      </Typography>

      <Typography
        className='BlogArticleModuleCentersMobile__locations'
        variant='h3-serif'
      >
        Our Locations:
      </Typography>

      <div className='BlogArticleModuleCentersMobile__cards'>
        {locations.map(({ item: location }) => (
          <BlogArticleModuleCentersCardMobile
            location={location}
            key={location.id}
            onClick={() => handleClick(location.id)}
            selected={location.id === selected}
          />
        ))}
      </div>

      <Button
        className='BlogArticleModuleCentersMobile__call-to-action'
        href='/sign-up'
        variant='dark'
      >
        Join Now
      </Button>
    </div>
  );
};
